import { useState, useCallback } from "react";
import type { ILocalePreference } from "@/types/localeTypes";
import {
  getLocalePreference,
  setLocalePreference,
  clearLocalePreference,
} from "@/utils/localeStorageHelpers";

interface IUseLocaleStorageResult {
  preference: ILocalePreference | null;
  saveLocale: (localeCode: string) => boolean;
  clearLocale: () => void;
  refreshPreference: () => void;
}

export function useLocaleStorage(): IUseLocaleStorageResult {
  const [preference, setPreference] = useState<ILocalePreference | null>(() =>
    getLocalePreference()
  );

  const saveLocale = useCallback((localeCode: string): boolean => {
    const success = setLocalePreference(localeCode);
    if (success) {
      setPreference(getLocalePreference());
    }
    return success;
  }, []);

  const clearLocale = useCallback((): void => {
    clearLocalePreference();
    setPreference(null);
  }, []);

  const refreshPreference = useCallback((): void => {
    setPreference(getLocalePreference());
  }, []);

  return {
    preference,
    saveLocale,
    clearLocale,
    refreshPreference,
  };
}
